export default __webpack_public_path__ + "static/media/cloud.506a2110.png";